module.exports = __webpack_public_path__ + "assets/img/13.7b4bf5fb.png";